/**
 * @fileoverview Barrel exports for structural-suggestions-v1.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
  type StructuralSuggestion,
  type MoveBeatSuggestion,
  type AddBeatSuggestion,
  type RemoveBeatSuggestion,
  type ChangePrioritySuggestion,
  type AddStorylineSuggestion,
} from './schema';

// Flow
export { flow, structuralSuggestionsV1AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
